import React, { Component } from "react";
import TopHeader from "../Header/TopHeader";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getDashboardDetails } from "../../constants/apiParams";
import { toast } from "react-toastify";
import { getUserID, setCellBackground, getStateGoalPercentage } from "../../util/utils";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { parse } from "graphql";

export default class ThisMonthDashboard extends React.Component{
  render() {
      const {
        myYear,
        thisMonth
      } = this.props;
      let brandGoals = {},
        brandSales = {};
      let totalBrandGoal = 0,
        totalBrandSale = 0;
      return (
        <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="col-md-12 m-b-30">
              <div className="card">
                <div className="card-header py-3">
                  <h4 className="h6 m-0">
                    {t("dashBoard.myMonth")}
                  </h4>
                </div>
                <div id="collapse-collapsed" class="collapse collapse-panel" aria-labelledby="heading-collapsed" data-toggle="collapse">
                  <div className="card-body pb-2">
                    <div className="table-responsive table-scroll">
                      <table className="table table-bordered small-table m-0">
                        <thead className="bg-light">
                          <tr>
                            <th>{t("dashBoard.team")}</th>
                            {myYear &&
                              myYear.map((item, index) => {
                                brandGoals = {
                                  ...brandGoals,
                                  [item.name]: 0,
                                };
                                brandSales = {
                                  ...brandSales,
                                  [item.name]: 0,
                                };
                                return (
                                  <th
                                    key={index}
                                    colspan="3"
                                    className="text-center thick-border"
                                  >
                                    {item.name && item.name}
                                  </th>
                                );
                              })}
                            <th
                              colspan="3"
                              className="text-center thick-border font-weight-bold"
                            >
                              {t("timeStatistic.sum")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td></td>
                            {myYear &&
                              myYear.map((item, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <td className="text-center">
                                      {t("teamStatistic.ziel")}{" "}
                                    </td>
                                    <td className="text-center">
                                      {t("teamStatistic.lst")}
                                    </td>
                                    <td className="text-center thick-border">
                                      {t("teamStatistic.in")}
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                            <td className="text-center font-weight-bold">
                              {t("teamStatistic.ziel")}{" "}
                            </td>
                            <td className="text-center font-weight-bold">
                              {t("teamStatistic.lst")}
                            </td>
                            <td className="text-center thick-border font-weight-bold">
                              {t("teamStatistic.in")}
                            </td>
                          </tr>
                          {thisMonth &&
                            thisMonth.map((item, index) => {
                              const brandList = item.brand_list.sort((a, b) =>
                                a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
                              );
                              let monthlyGoalSum = 0,
                                monthlySaleSum = 0;
                              return (
                                <tr key={index}>
                                  <td >{item.name}</td>
                                  {brandList &&
                                    brandList.map(
                                      (brand, brandIndex) => {
                                        if(brand.name!=='GW Ankauf'){
                                          monthlyGoalSum +=
                                            parseInt(
                                              brand.goal
                                            );
                                          monthlySaleSum +=
                                            parseInt(
                                              brand.sale
                                            );
                                        }
                                        brandGoals[
                                          brand.name
                                        ] += parseInt(
                                          brand.goal
                                        );
                                        brandSales[
                                          brand.name
                                        ] += parseInt(
                                          brand.sale
                                        );
                                        return (
                                          <React.Fragment
                                            key={brandIndex}
                                          >
                                            <td
                                              className={`text-center ${setCellBackground(
                                                brand.sale,
                                                brand.goal
                                              )}`}
                                            >
                                              {brand.goal}
                                            </td>
                                            <td
                                              className={`text-center ${setCellBackground(
                                                brand.sale,
                                                brand.goal
                                              )}`}
                                            >
                                              {brand.sale}
                                            </td>
                                            <td
                                              className={`text-center thick-border ${setCellBackground(
                                                brand.sale,
                                                brand.goal
                                              )}`}
                                            >
                                              {`${getStateGoalPercentage(
                                                brand.sale,
                                                brand.goal
                                              )}%`}
                                            </td>
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                  <td
                                    className={`${setCellBackground(
                                      monthlySaleSum,
                                      monthlyGoalSum
                                    )} text-center font-weight-bold`}
                                  >
                                    {monthlyGoalSum}
                                  </td>
                                  <td
                                    className={`${setCellBackground(
                                      monthlySaleSum,
                                      monthlyGoalSum
                                    )} text-center font-weight-bold`}
                                  >
                                    {monthlySaleSum}
                                  </td>
                                  <td
                                    className={`${setCellBackground(
                                      monthlySaleSum,
                                      monthlyGoalSum
                                    )} text-center thick-border font-weight-bold`}
                                  >
                                    {`${getStateGoalPercentage(
                                      monthlySaleSum,
                                      monthlyGoalSum
                                    )}%`}
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <td className="font-weight-bold">
                              {t("timeStatistic.sum")}
                            </td>
                            {myYear &&
                              myYear.map((brand, index) => {
                                if(brand.name!=='GW Ankauf'){
                                  totalBrandGoal +=
                                    brandGoals[brand.name];
                                  totalBrandSale +=
                                    brandSales[brand.name];
                                }
                                return (
                                  <React.Fragment key={index}>
                                    <td
                                      className={`${setCellBackground(
                                        brandSales[brand.name],
                                        brandGoals[brand.name]
                                      )} text-center font-weight-bold`}
                                    >
                                      {brandGoals[brand.name]}
                                    </td>
                                    <td
                                      className={`${setCellBackground(
                                        brandSales[brand.name],
                                        brandGoals[brand.name]
                                      )} text-center font-weight-bold`}
                                    >
                                      {brandSales[brand.name]}
                                    </td>
                                    <td
                                      className={`${setCellBackground(
                                        brandSales[brand.name],
                                        brandGoals[brand.name]
                                      )} text-center thick-border font-weight-bold`}
                                    >
                                      {`${getStateGoalPercentage(
                                        brandSales[brand.name],
                                        brandGoals[brand.name]
                                      )}%`}
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                            <td
                              className={`${setCellBackground(
                                totalBrandSale,
                                totalBrandGoal
                              )} text-center font-weight-bold`}
                            >
                              {totalBrandGoal}
                            </td>
                            <td
                              className={`${setCellBackground(
                                totalBrandSale,
                                totalBrandGoal
                              )} text-center font-weight-bold`}
                            >
                              {totalBrandSale}
                            </td>
                            <td
                              className={`${setCellBackground(
                                totalBrandSale,
                                totalBrandGoal
                              )} text-center thick-border font-weight-bold`}
                            >
                              {`${getStateGoalPercentage(
                                totalBrandSale,
                                totalBrandGoal
                              )}%`}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-0 ">
                  <div className="text-right">
                    <Link
                      to="/statistics/time"
                      className="font-weight-600"
                    >
                      {t("dashBoard.moreDetails")}
                    </Link>
                  </div>
                  <div className="text-left">
                    <a class="collapsed d-block" data-toggle="collapse" href="#collapse-collapsed" aria-expanded="true" aria-controls="collapse-collapsed" id="heading-collapsed"><i class="fa fa-chevron-up pull-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
          )
          }
        }
      </Translation>
    )
  }
}